export const bindInviteCodeKey = 'BindInviteCodeKey'